import { useTheme } from "@emotion/react";
import { alpha, Box } from "@mui/system";
import useStyles from "./styles";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Alert,
  Autocomplete,
  Button,
  Checkbox,
  Chip,
  Grid,
  LinearProgress,
  Paper,
  Snackbar,
  TextField,
  Typography,
} from "@mui/material";
import {
  CheckBox,
  CheckBoxOutlineBlank,
  ExpandMore,
  FilterAltOutlined,
  ManageAccountsOutlined,
} from "@mui/icons-material";
import api from "../../../../../../services/api";
import { useEffect, useState } from "react";

export default function ConfigTickets() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [allTipoAtendimento, setAllTipoAtendimento] = useState([]);
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [tiposSelecionadosInterno, setTiposSelecionadosInterno] = useState([]);
  const [tiposSelecionadosClient, setTiposSelecionadosClient] = useState([]);
  const [tiposSelecionaods, setTiposSelecionados] = useState({
    tiposSelecionadosClient: [],
    tiposSelecionadosInterno: [],
  });

  const icon = <CheckBoxOutlineBlank fontSize="small" />;
  const checkedIcon = <CheckBox fontSize="small" />;

  useEffect(() => {
    getAllTipoAtendimento();
  }, []);

  const getAllTipoAtendimento = async () => {
    setLoading(true);
    try {
      const response = await api.get("/interno/find/allTipoAtendimento");
      setAllTipoAtendimento(response?.data?.allTipoAtendimento);
      setTiposSelecionadosClient(response?.data?.allTipoAtendimentoClient);
      setTiposSelecionadosInterno(response?.data?.allTipoAtendimentoInterno);
      setTiposSelecionados((prev) => ({
        ...prev,
        tiposSelecionadosClient: response?.data?.allTipoAtendimentoClient,
        tiposSelecionadosInterno: response?.data?.allTipoAtendimentoInterno,
      }));
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const createFilter = async () => {
    try {
      const response = await api.post("/interno/create/filterTickets", {
        filterInterno: tiposSelecionadosInterno,
        filterClient: tiposSelecionadosClient,
      });

      setTiposSelecionados((prev) => ({
        ...prev,
        tiposSelecionadosClient: response?.data?.tipoAtendimentoClient,
        tiposSelecionadosInterno: response?.data?.tipoAtendimentoInterno,
      }));
      setTiposSelecionadosClient(response?.data?.tipoAtendimentoClient);
      setTiposSelecionadosInterno(response?.data?.tipoAtendimentoInterno);
      setIsEdit(false);
      setSnackbar({
        children: "Filtro de permissão atualizado com sucesso",
        severity: "success",
      });
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: "Erro ao atualizar filtro de permissão dos tickets.",
        severity: "error",
      });
    } finally {
    }
  };

  const handleCancel = () => {
    setIsEdit(false);
    setTiposSelecionadosClient(tiposSelecionaods?.tiposSelecionadosClient);
    setTiposSelecionadosInterno(tiposSelecionaods?.tiposSelecionadosInterno);
  };
  return (
    <>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMore />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Box sx={styles.containerHeader}>
            <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
              <FilterAltOutlined color="primary" />
              <Typography
                variant="h5"
                sx={{
                  ...styles.title,
                }}
              >
                Filtro de atendimentos por tipo
              </Typography>
            </Box>
          </Box>
        </AccordionSummary>
        <AccordionDetails>
          <Box sx={styles.paperContainer}>
            <Grid
              container
              spacing={1}
              columns={{ xs: 4, sm: 4, md: 4, lg: 4, xl: 4, xxl: 4 }}
            >
              <Grid item xs={4}>
                <Paper variant="outlined" sx={styles.paperConfig}>
                  <Box sx={{ mb: "10px" }}>
                    <Typography sx={{ fontWeight: "bold" }}>Interno</Typography>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box sx={styles.boxProgress}>
                      {loading && (
                        <LinearProgress
                          variant="indeterminate"
                          sx={styles.progress}
                        />
                      )}
                      <Autocomplete
                        loading={loading}
                        sx={{ width: "100%" }}
                        disabled={!isEdit}
                        multiple
                        id="checkboxes-tags-demo"
                        options={allTipoAtendimento || []}
                        value={tiposSelecionadosInterno || []}
                        onChange={(event, newValue) => {
                          setTiposSelecionadosInterno(newValue);
                        }}
                        disableCloseOnSelect
                        isOptionEqualToValue={(option, value) =>
                          String(option.id_tipo_atendimento) ===
                          String(value.id_tipo_atendimento)
                        }
                        getOptionLabel={(option) =>
                          `${option?.descricao} (${option?.id_tipo_atendimento})`
                        }
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={key} {...optionProps}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option?.descricao}
                            </li>
                          );
                        }}
                        renderTags={(value, getTagProps) =>
                          value?.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              label={option?.descricao}
                              size="small"
                              sx={{
                                ...styles.chip,
                                "& .MuiChip-deleteIcon": {
                                  color: theme.palette.white.main,
                                },
                              }}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Tipo de atendimento"
                          />
                        )}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      mt: "20px",
                      color: alpha(theme.palette.text.main, 0.5),
                    }}
                  >
                    <Typography sx={styles.description}>
                      Caso nenhum tipo de atendimento seja selecionado, todos os
                      tickets estarão disponíveis para visualização do lado
                      interno.
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
              <Grid item xs={4}>
                <Paper variant="outlined" sx={styles.paperConfig}>
                  <Box sx={{ mb: "10px" }}>
                    <Typography sx={{ fontWeight: "bold" }}>Cliente</Typography>
                  </Box>
                  <Box sx={{ width: "100%" }}>
                    <Box sx={styles.boxProgress}>
                      {loading && (
                        <LinearProgress
                          variant="indeterminate"
                          sx={styles.progress}
                        />
                      )}
                      <Autocomplete
                        loading={loading}
                        sx={{ width: "100%" }}
                        disabled={!isEdit}
                        multiple
                        id="checkboxes-tags-demo"
                        options={allTipoAtendimento || []}
                        value={tiposSelecionadosClient || []}
                        onChange={(event, newValue) => {
                          setTiposSelecionadosClient(newValue);
                        }}
                        isOptionEqualToValue={(option, value) =>
                          String(option.id_tipo_atendimento) ===
                          String(value.id_tipo_atendimento)
                        }
                        disableCloseOnSelect
                        getOptionLabel={(option) =>
                          `${option?.descricao} (${option?.id_tipo_atendimento})`
                        }
                        renderOption={(props, option, { selected }) => {
                          const { key, ...optionProps } = props;
                          return (
                            <li key={key} {...optionProps}>
                              <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={selected}
                              />
                              {option?.descricao}
                            </li>
                          );
                        }}
                        renderTags={(value, getTagProps) =>
                          value.map((option, index) => (
                            <Chip
                              {...getTagProps({ index })}
                              label={option?.descricao}
                              size="small"
                              sx={{
                                ...styles.chip,
                                "& .MuiChip-deleteIcon": {
                                  color: theme.palette.white.main,
                                },
                              }}
                            />
                          ))
                        }
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="outlined"
                            label="Tipo de atendimento"
                          />
                        )}
                      />
                    </Box>
                  </Box>
                  <Box
                    sx={{
                      mt: "20px",
                      color: alpha(theme.palette.text.main, 0.5),
                    }}
                  >
                    <Typography sx={styles.description}>
                      Caso nenhum tipo de atendimento seja selecionado, todos os
                      tickets estarão disponíveis para visualização lado do
                      cliente.
                    </Typography>
                  </Box>
                </Paper>
              </Grid>
            </Grid>
            <Box sx={styles.containerButtons}>
              {isEdit ? (
                <Box sx={{ display: "flex", gap: 1 }}>
                  <Button variant="outlined" onClick={handleCancel}>
                    Cancelar
                  </Button>
                  <Button onClick={createFilter} variant="contained">
                    Salvar
                  </Button>
                </Box>
              ) : (
                <Button
                  disabled={loading}
                  onClick={() => setIsEdit(true)}
                  variant="contained"
                >
                  Editar
                </Button>
              )}
            </Box>
            {!!snackbar && (
              <Snackbar
                open
                onClose={() => setSnackbar(null)}
                autoHideDuration={3000}
                anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
              >
                <Alert {...snackbar} onClose={() => setSnackbar(null)} />
              </Snackbar>
            )}
          </Box>
        </AccordionDetails>
      </Accordion>
    </>
  );
}
